import {css} from '@emotion/react'
import {EVENTS, logDplWithAppParams} from '../../../util/dpl'
import {getCountry} from '../../../util/getCountry'
import AppleIcon from '../../../images/app/AppleIcon.svg'
import GooglePlayIcon from '../../../images/vanish/icons/icn-play.svg'

const translations = {
    en: {
        downloadFor: 'Download for',
        iphone: 'iPhone',
        android: 'Android',
    },
    de: {
        downloadFor: 'Laden für',
        iphone: 'iPhone',
        android: 'Android',
    },
    nl: {
        downloadFor: 'Downloaden voor',
        iphone: 'iPhone',
        android: 'Android',
    },
}

// eslint-disable-next-line no-unused-vars
const DynamicDownloadButton = ({languageCode = 'en', experiment, os, browser, ctaType}) => {
    const text = translations[languageCode] || translations.en

    // Determine which device text and icon to use (link is same for both - Adjust auto-detects)
    const isAndroid = os === 'android'
    const deviceText = isAndroid ? text.android : text.iphone
    const DeviceIcon = isAndroid ? GooglePlayIcon : AppleIcon
    
    const downloadLink = 'https://startpage.go.link/40TNI'

    return (
        <a
            href={downloadLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${text.downloadFor} ${deviceText}`}
            css={css`
                display: flex;
                width: 304px;
                height: 45px;
                padding: 20px 16px;
                justify-content: center;
                align-items: center;
                gap: 12px;
                flex-shrink: 0;
                border-radius: 16px;
                background: #5668F1;
                box-shadow: 0px 0px 157.6px 0px #000;
                text-decoration: none;
                border: none;
                transition: all 0.2s ease;

                &:hover {
                    background: #7c3aed;
                    transform: translateY(-1px);
                }

                &:active {
                    transform: translateY(0);
                }
            `}
            onClick={() => {
                logDplWithAppParams(EVENTS.StartpageAppCtaClick, {
                    os,
                    country: getCountry(),
                    type: ctaType,
                    experiment,
                })
            }}
        >
            <DeviceIcon
                css={css`
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;

                    path {
                        fill: #f2f3fb;
                    }
                `}
            />
            <p
                css={css`
                    color: #F2F3FB;
                    text-align: center;
                    font-family: 'Inter';
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 30px;
                    margin: 0;

                    @media (max-width: 352px) {
                        font-size: 15px;
                    }
                `}
            >
                {text.downloadFor} {deviceText}
            </p>
        </a>
    )
}

export default DynamicDownloadButton
